import { Helmet } from 'react-helmet-async';
import react, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Button,
  Container,
  Stack,
  Typography,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
  Radio,
  Switch,
} from '@mui/material';
import { OrganizationOverview, NewOrganizationView } from '../components/organization';
// @mui
// components
import { getSignedInUser, signOut, getUserDetails } from '../services/authService';
import { getOrganization } from '../services/organizationService';
import { updateSettings } from '../services/userService';
import { infoNotification, errorNotification } from '../services/notificationService';

export default function AccountPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [displayTemperatureAsFahrenheit, setDisplayTemperatureAsFahrenheit] = useState(user?.settings?.playback?.displayTemperatureAsFahrenheit || false);

  const [isLoading, setIsLoading] = useState(true);

  const [organization, setOrganization] = useState(null);
  const [isLoadingOrganization, setIsLoadingOrganization] = useState(false);
  useEffect(() => {
    getUserDetails().then((userData) => {
      setDisplayTemperatureAsFahrenheit(userData?.settings?.playback?.displayTemperatureAsFahrenheit || false);
      setUser(userData);
      if (userData.organizationId) {
        setIsLoadingOrganization(true);
        getOrganization(userData.organizationId).then((organizationData) => {
          setOrganization(organizationData);
          setIsLoadingOrganization(false);
        });
      }
    }).catch((error) => {
      console.log(error);
      errorNotification(error.message);
    }).finally(() => {
      setIsLoading(false);
    });
  }, []);


  function handleChange(e) {
    const displayTemperatureAsFahrenheit = e;
    setDisplayTemperatureAsFahrenheit(displayTemperatureAsFahrenheit);
    const updatedUser = {
      ...user,
      settings: {
        ...user.settings,
        playback: {
          ...user.settings.playback,
          displayTemperatureAsFahrenheit,
        },
      },
    };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  }

  function handleSave() {
    updateSettings(user.settings).then((response) => {
      infoNotification("Settings saved");
    }).catch((error) => {
      errorNotification(error.response.data.message);
    });
  }


  function onLogoutClick() {
    signOut();
    navigate('/login');
  }

  if (!user) {
    return null;
  }

  console.log(user);

  return (
    <>
      <Helmet>
        <title> VPSI | Account </title>
      </Helmet>
      {isLoading ? (
        <CircularProgress />
      ) : (
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Account
          </Typography>
        </Stack>

        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <CardHeader title="Information" />
              <CardContent>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  <strong>Username:</strong> {user.username}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  <strong>Email:</strong> {user.email}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <CardHeader title="Settings" />
              <CardContent>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Manage your account settings and set email preferences.
                </Typography>
                <FormControl sx={{ my: 2 }} focused={false}>
                  <FormLabel>Temperature Scale</FormLabel>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={displayTemperatureAsFahrenheit}
                          onChange={(e) => handleChange(e.target.checked)}
                        />
                      }
                      label="Display temperature in Fahrenheit"
                    />
                </FormControl>
                <br />
                <br />
                <br />
                <Container disableGutters>
                  <Button variant="contained" color="primary" onClick={() => handleSave()}>
                    Save
                  </Button>
                </Container>
              </CardContent>
            </Card>
            </Grid>
            {organization && !isLoadingOrganization && (
              <Grid item xs={12} sm={12} md={12}>
                <OrganizationOverview organization={organization} />
              </Grid>
            )}
            {!organization && !isLoadingOrganization && (
              <Grid item xs={12} sm={12} md={12}>
                <NewOrganizationView />
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12}>
            <Card>
              <CardHeader title="Actions" />
              <CardContent>
                <br />
                <Button variant="contained" color="primary" fullWidth onClick={() => onLogoutClick()}>
                  Logout
                </Button>
              </CardContent>
            </Card>
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
}
